export default [
  {
    path: '/zkhl',
    component: () => import('./views/index')
  },
  {
    path: '/zkhl/list',
    props: (route) => ({
      title: route.query.title,
      id: route.query.id
    }),
    component: () => import('./views/list')
  }
]




// WEBPACK FOOTER //
// ./src/page/zkhl/route.js